export default __webpack_public_path__ + "static/media/dark-legacies-issue-1-variant 2.f328f450.webp";